<template>
  <div>
    <h3>About</h3>
    <p>This app built with Vue, Vuex, Router</p>
  </div>
</template>

<script>
export default {
  name: 'About',
}
</script>